module.exports = __webpack_public_path__ + "static/img/1052_big.dc9bddb.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/1052_big.png
// module id = H2rC
// module chunks = 1